import { Availability } from '../interfaces/Availability';
import { AvailabilityDto } from '../interfaces/dtos/AvailabilityDto';

export default function transformAvailability(dto: AvailabilityDto): Availability {
  let unavailability = dto.currentUnavailability;
  let isFuture = false;
  if (!unavailability && dto.futureUnavailability?.startAt) {
    unavailability = dto.futureUnavailability;
    isFuture = true;
  }
  return {
    isAuthorizedDuringMaintenance: dto.isAuthorizedDuringMaintenance,
    isAvailable: dto.isAvailable,
    unavailableFuture: isFuture ? new Date(unavailability.startAt) : null,
    unavailableUntil: unavailability?.endAt ? new Date(unavailability.endAt) : null,
  };
}
